import React from 'react';
import { Box, Icon, Divider, Body } from '@hover/blueprint';
import { Grid, GridItem } from '@chakra-ui/react';
import { iCheck, iX } from '@hover/icons';
import {
  HOVER_REPORTS_TABLE_HEADER,
  HOVER_REPORTS_TABLE_DATA,
} from '../../../constants';
import { IPricingTableHeader } from '../../../interfaces/IPricingTableHeader';
import HeaderCard from '../../pricing/choose-the-plan/HeaderCard';
import { IHoverReportTableData } from '../../../interfaces/IHoverReportTableData';

const Desktop: React.FC = () => (
  <Box w="100%" d={{ base: 'none', desktop: 'flex' }} flexDir="column">
    <Grid templateColumns="repeat(5, 1fr)" gap={600} mb={200}>
      <GridItem colSpan={3} />
      {HOVER_REPORTS_TABLE_HEADER.map((tableHeader: IPricingTableHeader) => (
        <HeaderCard card={tableHeader} key={tableHeader.id} h="140px" />
      ))}
    </Grid>
    {HOVER_REPORTS_TABLE_DATA.map((data: IHoverReportTableData) => (
      <Grid
        templateColumns="repeat(5, 1fr)"
        key={data.id}
        minH="64px"
        alignItems="center"
      >
        <GridItem colSpan={5}>
          <Divider
            borderColor="neutral.400"
            my={0}
            borderWidth={0}
            borderTopWidth="1px"
          />
        </GridItem>
        <GridItem colSpan={3}>
          <Body size={600} isSemiBold ml={600}>
            {data.title}
          </Body>
        </GridItem>
        <GridItem colSpan={1}>
          <Icon
            icon={data.roofOnly ? iCheck : iX}
            size="default"
            mx="auto"
            color={data.roofOnly ? 'success.600' : 'brandOrange.300'}
          />
        </GridItem>
        <GridItem colSpan={1}>
          <Icon
            icon={data.completeReport ? iCheck : iX}
            size="default"
            mx="auto"
            color={data.completeReport ? 'success.600' : 'brandOrange.300'}
          />
        </GridItem>
      </Grid>
    ))}
  </Box>
);

export default Desktop;
